import type { SVGProps } from "react";
import * as React from "react";

const SvgIconIntercom = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 75 75"
    {...props}
  >
    <rect
      width={75}
      height={75}
      fill="#fff"
      rx={14}
    />
    <path
      fill="#1F8DED"
      d="M12.333 41.486a2.334 2.334 0 0 0 4.667 0V20.5a2.334 2.334 0 0 0-4.667 0zm.815 14.605c.36.309 9.004 7.562 24.852 7.562s24.491-7.254 24.852-7.562a2.334 2.334 0 0 0-3.032-3.548c-.137.115-7.855 6.443-21.82 6.443-14.14 0-21.74-6.374-21.815-6.438a2.333 2.333 0 1 0-3.037 3.543M63.667 20.5a2.334 2.334 0 0 0-4.667 0v20.986a2.334 2.334 0 0 0 4.667 0zM52 15.833a2.334 2.334 0 0 0-4.667 0v31.172a2.334 2.334 0 0 0 4.667 0zm-11.667-1.18a2.332 2.332 0 1 0-4.666 0v33.833a2.333 2.333 0 0 0 4.666 0zm-11.666 1.18a2.334 2.334 0 0 0-4.667 0v31.172a2.333 2.333 0 0 0 4.666 0zM11.75 3h52.5A8.75 8.75 0 0 1 73 11.75v52.5A8.75 8.75 0 0 1 64.25 73h-52.5A8.75 8.75 0 0 1 3 64.25v-52.5A8.75 8.75 0 0 1 11.75 3"
    />
  </svg>
);
export default SvgIconIntercom;
